module.exports = __webpack_public_path__ + "static/rekino-9e696e9121237bd0b2a8a7f415bb925d.svg";